import { render, staticRenderFns } from "./PaymentThankYou.vue?vue&type=template&id=722b2889&scoped=true&"
import script from "./PaymentThankYou.vue?vue&type=script&lang=js&"
export * from "./PaymentThankYou.vue?vue&type=script&lang=js&"
import style0 from "./PaymentThankYou.vue?vue&type=style&index=0&id=722b2889&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722b2889",
  null
  
)

export default component.exports